import styled from 'styled-components'
import { Link as LinkCL } from 'syf-component-library/ui/atoms'
import { colors } from 'const/colors'
import query from 'mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const Link = styled(LinkCL)`
  display: none;
  position: absolute;
  top: -32px;
  padding: 4px;
  border-right: 1px solid ${colors.white};
  border-bottom: 1px solid ${colors.white};
  border-bottom-right-radius: 8px;
  background: ${colors.white};
  font-size: 16px;
  -webkit-transition: top 1s ease-out;
  transition: top 1s ease-out;
  z-index: 100;

  &:focus {
    top: 0;
    -webkit-transition: top 0.1s ease-in;
    transition: top 0.1s ease-in;
  }

  @media ${query.greaterThanMedium} {
    display: block;
  }
`

/**
 * padding: 4px;
 *border-right: 1px solid ${colors.white};
 *border-bottom: 1px solid ${colors.white};
 *border-bottom-right-radius: 8px;
 *background: ${colors.white};
 *font-size: 16px;
 *-webkit-transition: top 1s ease-out;
 *transition: top 1s ease-out;
 *z-index: 100;
 *
 *&:focus {
 *  top: -16px;
 *  outline-color: transparent;
 *  -webkit-transition: top 0.1s ease-in;
 *  transition: top 0.1s ease-in;
 *}
 */
